import React from "react";
import { Constants } from "../utils/constants";

const HEventTypeToggle = ({ activeType, onTypeChange }) => {
  const getInactiveStyles = () => {
    return {
      color: Constants.HOST_EXPERIENCE_BASE_COLOR,
      opacity: 0.7,
    };
  };

  const getHoverStyles = () => {
    return {
      color: Constants.HOST_EXPERIENCE_BASE_COLOR,
      opacity: 0.9,
    };
  };

  return (
    <div
      className="rounded-full p-1 mb-6 inline-flex"
      style={{ backgroundColor: `${Constants.HOST_EXPERIENCE_BASE_COLOR}15` }}
    >
      <button
        onClick={() => onTypeChange("event")}
        className={`px-6 py-2 rounded-full font-medium transition-all ${activeType === "event" ? "text-white shadow-sm" : ""}`}
        style={activeType === "event" ? { backgroundColor: Constants.HOST_EXPERIENCE_BASE_COLOR } : getInactiveStyles()}
        onMouseOver={e => {
          if (activeType !== "event") {
            Object.assign(e.currentTarget.style, getHoverStyles());
          }
        }}
        onMouseOut={e => {
          if (activeType !== "event") {
            Object.assign(e.currentTarget.style, getInactiveStyles());
          }
        }}
      >
        Event
      </button>
      <button
        onClick={() => onTypeChange("post")}
        className={`px-6 py-2 rounded-full font-medium transition-all ${activeType === "post" ? "text-white shadow-sm" : ""}`}
        style={activeType === "post" ? { backgroundColor: Constants.HOST_EXPERIENCE_BASE_COLOR } : getInactiveStyles()}
        onMouseOver={e => {
          if (activeType !== "post") {
            Object.assign(e.currentTarget.style, getHoverStyles());
          }
        }}
        onMouseOut={e => {
          if (activeType !== "post") {
            Object.assign(e.currentTarget.style, getInactiveStyles());
          }
        }}
      >
        Post
      </button>
    </div>
  );
};

export default HEventTypeToggle;
